<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px">
    <v-card :color="color" dark>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-text>
        <v-container>
          <form action>
            <v-row>
              <v-col cols="12" xs="6" sm="12">
                <v-text-field
                  :color="icon_color"
                  v-model="item.first_name"
                  label="Nombre"
                  hint="obligatorio"
                  persistent-hint
                  data-vv-name="first_name"
                  v-validate="'required|max:30|alpha_spaces'"
                  :error-messages="errors.collect('first_name')"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" xs="6" sm="12">
                <v-text-field
                  :color="icon_color"
                  v-model="item.last_name"
                  label="Apellido"
                  data-vv-name="last_name"
                  hint="obligatorio"
                  persistent-hint
                  v-validate="'required|max:30|alpha_spaces'"
                  :error-messages="errors.collect('last_name')"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" xs="6" sm="12">
                <v-text-field
                  :color="icon_color"
                  v-model="item.email"
                  label="Correo"
                  hint="obligatorio"
                  persistent-hint
                  data-vv-name="email"
                  v-validate="'required|email'"
                  :error-messages="errors.collect('email')"
                  :disabled="disabled"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
                xs="6"
                sm="12"
                v-if="item.email_confirmation === 1"
              >
                <p>Activar</p>
                <v-switch :color="icon_color" v-model="item.state"></v-switch>
              </v-col>
              <v-col
                cols="12"
                xs="6"
                sm="12"
                v-else-if="index != -1 && item.email_confirmation === 0"
              >
                <p>Activar</p>
                <v-switch :disabled="disabled"></v-switch>
                <p>{{ text }}</p>
              </v-col>
            </v-row>
          </form>
        </v-container>
      </v-card-text>
      <v-divider class="mx-4"></v-divider>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn :color="link" text @click="save">Guardar</v-btn>
        <v-btn :color="link" text @click="close">Cancelar</v-btn>
        <p style="visibility: hidden; font-size: 0.01px">
          {{ reloadValidador }}
        </p>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    index: Number,
    item: Object,
    value: Boolean,
    disabled: Boolean,
  },
  computed: {
    ...mapState({
      color: (state) => state.layout.color,
      icon_color: (state) => state.layout.icon_color,
      link: (state) => state.layout.link,
      administrators: (state) => state.administrator.administrators,
    }),
    reloadValidador() {
      if (this.index === -1) this.$validator.reset()
      return this.item.first_name[0]
    },
    formTitle() {
      if (this.index === -1) this.$validator.reset()
      return this.index === -1 ? 'Nuevo administrador' : 'Editar administrador'
    },
    text() {
      return this.item.email_confirmation === 0
        ? '* El correo no está confirmado'
        : ''
    },
  },
  data() {
    return {
      dialog: false,
      dictionary: {
        custom: {
          first_name: {
            required: () => 'Nombre no puede ser vacío',
            max: () => 'El nombre debe ser máximo de 30 caracteres',
            alpha_spaces: () => 'Nombre debe contener solo letras',
          },
          last_name: {
            required: () => 'Apellido no puede ser vacío',
            max: () => 'El apellido debe ser máximo de 30 caracteres',
            alpha_spaces: () => 'Apellido debe contener solo letras',
          },
          email: {
            required: () => 'Correo no puede ser vacío',
            email: () =>
              'El campo Correo debe ser un correo electronico válido',
          },
        },
      },
    }
  },
  mounted() {
    this.$validator.localize('es', this.dictionary)
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    close() {
      this.$validator.reset()
      this.$emit('input', false)
    },
    admistratorMail() {
      return this.administrators.filter(
        (element) => element.email == this.item.email
      )
    },
    async save() {
      let isValidForm = await this.$validator.validateAll()
      if (isValidForm) {
        if (this.index > -1) {
          this.$store.dispatch('administrator/updateAdministrator', this.item)
        } else {
          if (!this.admistratorMail().length) {
            this.$store.dispatch('administrator/createAdministrator', this.item)
          } else {
            this.userExistMessage(this.item)
          }
        }
        this.$validator.reset()
        this.close()
      }
    },
    userExistMessage(item) {
      this.$swal({
        html:
          `<span style="color: #0288D1; font-family: Helvetica">${item.email}</span>` +
          `<br>` +
          `<br>` +
          `<span style="color: white; font-family: Helvetica">El e-mail ingresado ya se encuentra registrado como administrador<span>`,
        type: 'error',
        animation: false,
        background: '#1e1e2f',
        width: '350px',
        confirmButtonColor: '#1E87F7',
        showConfirmButton: true,
        confirmButtonText:
          "<span style='font-family: Helvetica'>Aceptar</span>",
      })
    },
  },
}
</script>
<style scoped>
.text-input-blue .v-text-field__slot input {
  color: rgba(64, 187, 150, 0.541) !important;
}
</style>